import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './contexts/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Contact from './pages/Contact';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Success from './pages/Success';
import DocumentComptable from './pages/DocumentComptable';
import RetrouverFacture from './pages/RetrouverFacture';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import GameRules from './pages/GameRules';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import TermsOfService from './pages/legal/TermsOfService';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import PaymentSecurity from './pages/legal/PaymentSecurity';
import LegalNotice from './pages/legal/LegalNotice';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import CookieConsent from './components/CookieConsent';
import ErrorBoundary from './components/ErrorBoundary';
import AudienceTracker from './components/AudienceTracker';
import ScrollToTop from './components/ScrollToTop';


function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <LanguageProvider>
        <CartProvider>
          <AuthProvider>
            <Router>
              <AudienceTracker />
              <ScrollToTop />
              <div className="flex flex-col min-h-screen bg-[#F7F4EE]">
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/regles-de-jeu" element={<GameRules />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/success" element={<Success />} />
                    <Route path="/facture/:numero" element={<DocumentComptable type="facture" />} />
                    <Route path="/note-de-credit/:numero" element={<DocumentComptable type="note-de-credit" />} />
                    <Route path="/ma-facture" element={<RetrouverFacture />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/profile/orders" element={<Profile />} />
                    <Route path="/admin" element={
                      <ProtectedRoute allowedRoles={['admin', 'developer']}>
                        <Admin />
                      </ProtectedRoute>
                    } />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/terms" element={<TermsOfService />} />
                    <Route path="/privacy" element={<PrivacyPolicy />} />
                    <Route path="/payment-security" element={<PaymentSecurity />} />
                    <Route path="/legal" element={<LegalNotice />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            </Router>
          </AuthProvider>
        </CartProvider>
        <CookieConsent />
        </LanguageProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
